import React, { useEffect, useRef, useState } from "react";

export default function SplashVideoOverlay({
  durationMs = 3000,
  minWidthPx = 768,
  onlyPath = "/",
}) {
  const [open, setOpen] = useState(false);
  const shownRef = useRef(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.location.pathname !== onlyPath) return;
    if (window.innerWidth < minWidthPx) return;
    if (shownRef.current) return;

    // Only show once per browser session
    const key = "589labs_splash_shown";
    if (sessionStorage.getItem(key)) return;

    shownRef.current = true;
    sessionStorage.setItem(key, "1");
    setOpen(true);
  }, [minWidthPx, onlyPath]);

  useEffect(() => {
    if (!open) return;

    // Prevent background scrolling while splash is open
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const t = window.setTimeout(() => {
      setOpen(false);
    }, durationMs);

    return () => {
      window.clearTimeout(t);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, durationMs]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/70 p-6 backdrop-blur-sm">
      <div className="w-full max-w-xl">
        <img
          src="/splash_static.png"
          alt="589 Labs"
          className="mx-auto block w-full"
        />
      </div>
    </div>
  );
}
